import base from '@/http/url_base';

export default {
  OF: base.API_GPAO + '/ofs',
  GET_REQUIREMENTS: base.API_GPAO + '/ofs/requirements',
  GET_ETAPES: base.API_GPAO + '/ofs/etapes',

  REINITIALISER: base.API_GPAO + '/ofs/reinitialiser',
  DEMARRER: base.API_GPAO + '/ofs/demarrer',
  REDEMARRER: base.API_GPAO + '/ofs/redemarrer',
  ARRETER: base.API_GPAO + '/ofs/arreter',
  TERMINER: base.API_GPAO + '/ofs/terminer',
};
